import { render, staticRenderFns } from "./ProductActionMassDelete.vue?vue&type=template&id=5a999124&"
import script from "./ProductActionMassDelete.vue?vue&type=script&lang=ts&"
export * from "./ProductActionMassDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports